import { render, staticRenderFns } from "./connection-header.vue?vue&type=template&id=7f5736c6&scoped=true&"
import script from "./connection-header.vue?vue&type=script&lang=ts&"
export * from "./connection-header.vue?vue&type=script&lang=ts&"
import style0 from "./connection-header.vue?vue&type=style&index=0&id=7f5736c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5736c6",
  null
  
)

export default component.exports